import { Link } from "react-router-dom";

export default function Footer() {
  const goto = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="bg-[#1A1A1A] text-[#FAF9F6]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="font-serif-display text-5xl md:text-6xl leading-none mb-6">CoworkingVilla</div>
            <p className="eyebrow text-[#BFA588] mb-8">Villa Porcelaine · Keszthely</p>
            <p className="text-[#FAF9F6]/70 max-w-md leading-relaxed text-[15px]">
              Foglalj asztalt, tárgyalót vagy teljes irodát egy XIX. századi villában – a Balaton-parttól pár percre.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow text-[#BFA588] mb-6">Navigáció</p>
            <ul className="space-y-3 text-[15px]">
              {[
                ["bemutatkozas", "Bemutatkozás"],
                ["szolgaltatasok", "Szolgáltatások"],
                ["foglalas", "Foglalás"],
                ["galeria", "Galéria"],
                ["kapcsolat", "Kapcsolat"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    onClick={() => goto(id)}
                    data-testid={`footer-nav-${id}`}
                    className="text-[#FAF9F6]/70 hover:text-[#BFA588] transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="eyebrow text-[#BFA588] mb-6">Kapcsolat</p>
            <ul className="space-y-3 text-[15px] text-[#FAF9F6]/70">
              <li><a href="mailto:info@villaporcelaine.com" className="hover:text-[#BFA588]">info@villaporcelaine.com</a></li>
              <li><a href="tel:+36304549308" className="hover:text-[#BFA588]">+36 30 454 9308</a></li>
              <li>Villa Porcelaine<br />Erzsébet királyné útja 38.<br />8360 Keszthely</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[12px] tracking-[0.2em] uppercase text-[#FAF9F6]/50">
          <p data-testid="footer-copyright">© 2024 CoworkingVilla – Minden jog fenntartva.</p>
          <div className="flex items-center gap-6">
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#BFA588]">Admin</Link>
            <a
              href="https://www.boldigital.hu/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-boldigital-link"
              className="text-[#FAF9F6]/50 hover:text-[#BFA588] hover:underline underline-offset-4 transition-colors duration-300"
            >
              Design by Boldigital
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
